import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';
import { defineRxdbCollectionModel } from './migration';

export const DIARY_DAY_OUTBOX_COLLECTION = 'diaryDayOutbox' as const;
export const DIARY_DAY_OUTBOX_SCHEMA_VERSION = 0;

export const diaryDayOutboxSchemaLiteral = {
  title: 'diary day outbox schema',
  version: DIARY_DAY_OUTBOX_SCHEMA_VERSION,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    userId: { type: 'string', maxLength: 100 },
    generation: { type: 'string', maxLength: 100 },
    changedAt: { type: 'string', maxLength: 30 },
    pending: { type: 'boolean' },
  },
  required: ['id', 'userId', 'generation', 'changedAt', 'pending'],
  indexes: [['userId', 'pending', 'changedAt']],
} as const;

export type DiaryDayOutboxDocType =
  ExtractDocumentTypeFromTypedRxJsonSchema<typeof diaryDayOutboxSchemaLiteral>;

export const diaryDayOutboxSchema: RxJsonSchema<DiaryDayOutboxDocType> =
  diaryDayOutboxSchemaLiteral;

export const diaryDayOutboxModel = defineRxdbCollectionModel<
  typeof DIARY_DAY_OUTBOX_COLLECTION,
  DiaryDayOutboxDocType
>({
  collection: DIARY_DAY_OUTBOX_COLLECTION,
  schema: diaryDayOutboxSchema,
});
